export function isVerifiedProvider(provider = "") {
  return provider === "google.com" || provider === "yahoo.com" ? true : false;
}
